import { ContentBlocks } from "eddev/blocks"
import { defineView } from "eddev/views"
import { useIsPresent } from "motion/react"

export default defineView("front-page", (props) => {
  const isPresent = useIsPresent()

  return (
    <div className="bg-cardboard">
      <ContentBlocks blocks={props.page?.contentBlocks} />
    </div>
  )
})
